import { render, staticRenderFns } from "./HomeProductSales.vue?vue&type=template&id=49b134f8&scoped=true&"
import script from "./HomeProductSales.vue?vue&type=script&lang=js&"
export * from "./HomeProductSales.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductSales.vue?vue&type=style&index=0&id=49b134f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b134f8",
  null
  
)

export default component.exports